import React from 'react'
import { verifyNullValue } from '@auteco/utils/verifyNullValue'
import { Card, TextField, Typography } from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'
import useStyles from './styles'

const AutocompleteToSearch = ({ label, options, onChange }) => {
    const classes = useStyles()

    const title = label === 'Grupos' ? 'grupo' : 'perfil'
    return (
        <Card className={classes.card}>
            <Typography className={classes.title} >Buscar materiales por {title}</Typography>
            <Autocomplete
                label={label}
                options={options}
                className={classes.textField}
                getOptionLabel={(option) => option.nombre}
                renderInput={(params) => <TextField {...params} label={label} variant='outlined' />}
                onChange={(e, newValue) => onChange({ id: verifyNullValue({ value: newValue, param: 'id' }), })}
            />
        </Card>
    )
}

export { AutocompleteToSearch }